import { render, staticRenderFns } from "./AuthorMore.vue?vue&type=template&id=8160efa4&scoped=true&"
import script from "./AuthorMore.vue?vue&type=script&lang=js&"
export * from "./AuthorMore.vue?vue&type=script&lang=js&"
import style0 from "./AuthorMore.vue?vue&type=style&index=0&id=8160efa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8160efa4",
  null
  
)

export default component.exports